import { useTranslation } from "../../hooks";
import classes from "../../styles/History.module.css";
import { formatTime, formatCurrency, Currency } from "../../utils";

const Description: React.FC<{
  data: any;
  visible: boolean;
  currency: Currency;
}> = ({ data, visible, currency }) => {
  const texts = {
    date: useTranslation("rounddate"),
    bet: useTranslation("historybet"),
    payout: useTranslation("historypayout"),
    balance: useTranslation("endbalance"),
    prevbalance: useTranslation("prevbalance"),
    sessionId: useTranslation("sessionId"),
    roundId: useTranslation("roundId"),
    currency: useTranslation("currency"),
  };

  if (!visible) return <div></div>;

  return (
    <div className={classes["round-description"]}>
      <div>{texts.roundId}:</div>
      <div>
        <b>{data.roundId}</b>
      </div>
      <div>{texts.sessionId}:</div>
      <div>
        <b>{data.sessionId}</b>
      </div>
      <div>{texts.date}:</div>
      <div>
        <b>{formatTime(data.created)}</b>
      </div>
      <div>{texts.currency}: </div>
      <div>
        <b>{currency.code}</b>
      </div>
      <div>{texts.bet}:</div>
      <div>
        <b>{formatCurrency(data.bet, currency)}</b>
      </div>
      <div>{texts.payout}:</div>
      <div>
        <b>{formatCurrency(data.win, currency)}</b>
      </div>
      <div> {texts.prevbalance}: </div>
      <div>
        <b>{formatCurrency(data.openningBalance, currency)}</b>
      </div>
      <div> {texts.balance}: </div>
      <div>
        <b>{formatCurrency(data.closingBalance, currency)}</b>
      </div>
    </div>
  );
};

export default Description;
